import { render } from "./ProjectsAnalysisChart.vue?vue&type=template&id=9ae2c8fa&ts=true"
import script from "./ProjectsAnalysisChart.vue?vue&type=script&lang=ts"
export * from "./ProjectsAnalysisChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__